export enum RodzajRaportu {
    arkuszSpisu,
    niedobory,
    nadwyzki
}